 <!-- 仓储天数报表 -->
 <template>
    <diV style="background-color: white; height: calc(100vh - 84px); display: flex; flex-direction: column;">
        <el-form class="demo-form-inline" :inline="true" ref="dayStockReportForm" :model="dayStockReportForm" 
        size="mini" label-width="100px">
            <el-form-item label="仓库" prop="ckName">
                <el-select placeholder="请选择仓库" v-model="dayStockReportForm.ckName" >
                    <el-option v-for="item in ckNameList" :key="item" :label="item" :value="item"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="客户" prop="customerName">
                <el-select filterable placeholder="请选择货主单位" v-model="dayStockReportForm.customerName" clearable >
                    <el-option v-for="item in customerList" :key="item.id" :label="item.companyName" :value="item.companyName"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="" prop="">
                <el-radio-group v-model="dayStockReportForm.sign">
                    <el-radio :label="1">查看当月</el-radio>
                    <el-radio :label="2">查看全部</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary" @click="wmsGetDayStockDays">搜索</el-button>
                <el-button type="primary" @click="dayStockDaysExport">导出</el-button>
            </el-form-item>
        </el-form>
        <div style="flex:1;overflow: hidden;">
            <vxe-table id="dayStockReportTable"  size="mini" ref="dayStockReportTable" :data="dayStockReportList" border stripe
            header-align="center"  max-height="85%"
            :row-config="{isCurrent: true, isHover: true}">
                <vxe-column type="seq" width="60"></vxe-column>
                <vxe-column field="customerName" title="客户名称" ></vxe-column>
                <vxe-column field="blNo" title="提单号" ></vxe-column>
                <vxe-column field="inTons" title="当月入库数量（吨）" width="200" ></vxe-column>
                <vxe-column field="outTons" title="当月出库数量（吨）" width="200"  ></vxe-column>
                <vxe-column field="inStockTons" title="在库数量（吨）" width="200"  ></vxe-column>
                <vxe-column field="storageDays" title="仓储天数（天）" width="200"  ></vxe-column>
                <vxe-column field="stockLevel" title="仓库等级" width="200"  ></vxe-column>
            </vxe-table>
            <div class="warning">
                <p>30天内为<strong>A</strong>，30-60为<strong>B</strong>，60-90为<strong>C</strong>，90-120为<strong>D</strong>，
                    120-150为<strong>E</strong>，150-180天为<strong>F</strong>，大于180天为<strong>G</strong></p>
            </div>
        </div>
    </diV>
</template>
<script>
import ExcelJS from 'exceljs';
import userProfile from '@/mixins/userProfile.js'
import basicData from '@/config/basicData.js'
import AEObasicData from '@/config/AEObasicData.js'
import clean from 'lodash-clean';
import { webapp_ws_ajax_run, webapp_urlprotocol_startup, urlAddRandomNo,webapp_ws_autoupdate, webapp_ws_ajax_together } from "../../utils/reports/grwebapp";

export default {
    name: 'dayStockReport',
    mixins: [userProfile],
    components:{

    },
    watch: { 
       
    },
    data() {
        return{
            dayStockReportForm:{
                ckName:"",
                customerName:"",
                sign:1,
            },
            dayStockReportList:[],
            ckNameList:[], // 获取仓库列表
            customerList:[], // 获取客户列表
        }
    },
    async created() {

        await this.getckNameList()
        await this.wmsGetDayStockDays()
        this.getCompanyList()
    },
    mounted() {

    },
    methods: {
        // 获取数据
        wmsGetDayStockDays() { 
            // 如果是1
            if( this.dayStockReportForm.sign === 1 ){
                return this.$api.wmsGetDayStockDays(this.dayStockReportForm.ckName,this.dayStockReportForm.customerName).then(res =>{
                    this.dayStockReportList = res
                })
            }else if( this.dayStockReportForm.sign === 2 ){
                return this.$api.wmsGetDayAllStockDays(this.dayStockReportForm.ckName,this.dayStockReportForm.customerName).then(res =>{
                    this.dayStockReportList = res
                })
            }
            
        },
        // 获取仓库
        getckNameList(){
            return this.$api.getCkNamesBy(  ).then(res =>{
               this.ckNameList = res
               this.dayStockReportForm.ckName = this.ckNameList[0]
            })
        },
        // 获取客户信息
        getCompanyList(){
            this.$api.getCompanyList(  ).then(res =>{
                this.customerList = res.tableData
            })
        },
        // 导出
        async dayStockDaysExport(){
            var master = {
                ckName: this.dayStockReportForm.ckName,
            }
            const params = { 
                master:master,
                table:this.dayStockReportList,

            }
            let downloadName = `${this.dayStockReportForm.ckName}天数统计报表.xls`

            var args = {
                report: urlAddRandomNo("/grf/仓库天数报表.grf"),
                data: params,
                type: "xls",
                filename: downloadName,
                ExportPageBreak: false, // 导出Excel时是否保留分页符
                ExportPageHeaderFooter: false, // 导出Excel时是否保留页眉页脚
                SameAsPrint: false, // 导出Excel时是否与和纸质打印一致
                showOptionDlg: true, // 是否弹出导出设置弹窗
                ExcelKeepCellFormat: true,// 导出Excel时是否保持单元格格式
            };
            webapp_ws_ajax_run(args);
        },
    }
}
</script>
<style lang="less" scoped>
 .warning {
    padding: 8px 16px;
    background-color: #fff6f7;
    border-radius: 4px;
    border-left: 5px solid #fe6c6f;
    margin: 20px 0;
    font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
    font-weight: 400;
    -webkit-font-smoothing: antialiased;
    -webkit-tap-highlight-color: transparent;
    font-size: 14px;
}
</style>